<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>{{ $t('auto.labels.additionalPhoto') }}</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex flex-wrap">
        <div
          v-for="(photo, idx) in credentials.additionalPhoto"
          :key="photo.name"
          class="col-xl-2 col-md-3 col-sm-6 cols-12"
        >
          <div class="img-uploader">
            <image-uploader-new
              :photo.sync="credentials.additionalPhoto[idx]"
              outlined
              @update:photo="onPhotoUpdate"
            />
          </div>
        </div>

        <div class="col-xl-2 col-md-3 col-sm-6 cols-12">
          <div class="img-uploader">
            <image-uploader-new
              :photo.sync="credentials.additionalPhoto[photoLastIdx]"
              outlined
            />
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="additional-comment" cols="12">
        <v-textarea
          v-model="credentials.additionalPhotoComment"
          height="100"
          filled
          no-resize
          :label="$t('auto.labels.additionalPhotoComment')"
        />
      </v-col>
    </v-row>

    <v-divider />

    <v-row>
      <v-col cols="12">
        <h3>{{ $t('auto.labels.additionalVideo') }}</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex flex-wrap">
        <div
          v-for="(video, idx) in credentials.additionalVideo"
          :key="video.name"
          class="col-xl-2 col-md-3 col-sm-6 cols-12"
        >
          <div class="img-uploader">
            <video-uploader
              :video.sync="credentials.additionalVideo[idx]"
              outlined
              @update:video="onVideoUpdate"
            />
          </div>
        </div>

        <div class="col-xl-2 col-md-3 col-sm-6 cols-12">
          <div class="img-uploader">
            <video-uploader
              :video.sync="credentials.additionalVideo[videoLastIdx]"
              outlined
            />
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="additional-comment" cols="12">
        <v-textarea
          v-model="credentials.additionalVideoComment"
          height="100"
          filled
          no-resize
          :label="$t('auto.labels.additionalVideoComment')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ImageUploaderNew from '@/components/shared/ImageUploader.vue';
import VideoUploader from '@/components/shared/VideoUploader.vue';

export default {
  components: {
    ImageUploaderNew,
    VideoUploader,
  },
  data: () => ({
    credentials: {
      additionalPhoto: [],
      additionalVideo: [],
      additionalPhotoComment: '',
      additionalVideoComment: '',
    },
  }),
  computed: {
    photoLastIdx() {
      return this.credentials.additionalPhoto.length;
    },
    videoLastIdx() {
      return this.credentials.additionalVideo.length;
    },
  },
  methods: {
    getComponentData() {
      const {
        additionalPhoto,
        additionalVideo,
        additionalPhotoComment,
        additionalVideoComment,
      } = this.credentials;

      this.$emit('update:additionalPhoto', additionalPhoto);
      this.$emit('update:additionalVideo', additionalVideo);
      this.$emit('update:additionalPhotoComment', additionalPhotoComment);
      this.$emit('update:additionalVideoComment', additionalVideoComment);
    },
    onPhotoUpdate() {
      this.credentials.additionalPhoto = this.credentials.additionalPhoto.filter(
        (photo) => Boolean(photo),
      );
    },
    onVideoUpdate() {
      this.credentials.additionalVideo = this.credentials.additionalVideo.filter(
        (video) => Boolean(video),
      );
    },
    writeDataToFields(data) {
      this.credentials = data;
    },
  },
};
</script>

<style>
.additional-comment {
  margin-top: 15px;
  padding: 0 24px;
  max-width: 700px;
}

.img-uploader {
  height: 220px;
}

h3 {
  font-weight: 300;
}
</style>
